<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="modalHeading"
  (closeButtonClicked)="handleCloseModal()"
>
  <qai-field [label]="fieldLabel">
    @if (treeData.length === 0) {
      <qai-tree-select
        placeholder="Simulation name"
        [isSimulationMode]="true"
        [treeData]="[]"
      ></qai-tree-select>
    } @else {
      <qai-tree-select
        [treeData]="treeData"
        (selectionsSave)="onSelectionSave($event)"
        [showCount]="false"
        [isSimulationMode]="true"
        placeholder="Simulation name"
        maxHeight="30dvh"
      ></qai-tree-select>
    }

    <span qaiSlot="label" *ngIf="selectedSimulations.length > 0">
      <button qai-link class="remove-all-button" (click)="onRemoveAll()">
        Remove all
      </button>
    </span>
  </qai-field>

  <div
    *ngIf="selectedSimulations.length > 0"
    class="selected-simulation-wrapper"
  >
    <qai-field label="Simulations in the assignment">
      <qai-selected-simulations-list
        [simulations]="selectedSimulations"
        (remove)="onRemove($event)"
        maxHeight="300px"
        [showAttemptsAllowed]="showAttemptsAllowed"
        (attemptsChange)="onAttemptsChange($event.id, $event.attempts)"
        (simulationsChange)="onSimulationListSelectionChange($event)"
      ></qai-selected-simulations-list>
    </qai-field>
  </div>
 
  <div
    class="action-button-container"
    *ngIf="isCreateAssignmentFlow; else addButton"
  >
    <button
      qai-button
      size="medium"
      kind="secondary"
      (click)="handleBackAndCloseClick()"
    >
      Back
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="networkRequestInProgress || selectedSimulations.length === 0"
      (click)="assignSimulationsToAssignment()"
    >
      Assign learners
    </button>
  </div>

  <ng-template #addButton>
    <div class="action-button-container single-button">
      <button
        qai-button
        size="medium"
        kind="primary"
        [disabled]="networkRequestInProgress || selectedSimulations.length === 0"
        (click)="assignSimulationsToAssignment()"
      >
        Add to Assignment
      </button>
    </div>
  </ng-template>
</dialog>
